<template>
  <v-icon :color="color" :size="size">
    {{ icon }}
  </v-icon>
</template>

<script>
import { NodeStatus, Icon, Severity } from '@/model/node'

export default {
  data () {
    return {}
  },
  props: {
    severity: Severity,
    size: Number,
    status: NodeStatus
  },
  computed: {
    color () {
      if (this.status !== NodeStatus.ONLINE) {
        return 'unknown'
      }
      switch (this.severity) {
        case Severity.SUCCESS:
          return 'success'
        case Severity.UNKNOWN:
          return 'unknown'
        case Severity.MINOR:
          return 'warning'
        case Severity.MAJOR:
          return 'major'
        case Severity.CRITICAL:
          return 'error'
        default:
          return 'unknown'
      }
    },
    icon () {
      switch (this.severity) {
        case Severity.SUCCESS:
          return Icon.SUCCESS
        case Severity.UNKNOWN:
          return Icon.UNKNOWN
        case Severity.MINOR:
          return Icon.MINOR
        case Severity.MAJOR:
          return Icon.MAJOR
        case Severity.CRITICAL:
          return Icon.CRITICAL
        default:
          return Icon.UNKNOWN
      }
    }
  }
}
</script>